import { AssetTypeMaintenanceScheduleAttributes } from '@/types'
import { CreateAssetTypeMaintenanceScheduleMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'

interface Props {
  onSuccess: () => void
  defaultValues: Partial<AssetTypeMaintenanceScheduleAttributes>
}

export const Form = ({ onSuccess, defaultValues }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreateAssetTypeMaintenanceScheduleMutation, AssetTypeMaintenanceScheduleAttributes, never, never>({
    defaultValues: {
      assetTypeId: '',
      maintenanceScheduleId: '',
      ...defaultValues
    },
    mutation: CreateMutation,
    resultKey: 'createAssetTypeMaintenanceSchedule',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({
        name: 'Schedule',
        field: 'maintenanceScheduleId',
        type: 'asset-type-maintenance-schedule'
      }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
